import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appInputAutosize]',
  standalone: false,
})
export class InputAutosizeDirective implements OnInit {
  @Input() appAutosizeInput = 0;
  private padding = 12;
  private style: any;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.style = getComputedStyle(this.el.nativeElement);
    this.adjustWidth();
  }

  @HostListener('input')
  onInput() {
    this.adjustWidth();
  }

  private adjustWidth() {
    this.renderer.setStyle(this.el.nativeElement, 'width', 'auto');
    const width = this.getTextWidth(this.el.nativeElement.value) + this.padding;
    this.renderer.setStyle(this.el.nativeElement, 'width', `${width}px`);
  }

  private getTextWidth(value: string): number {
    const element = this.renderer.createElement('canvas');
    const context = element.getContext('2d');

    const {
      fontStyle,
      fontVariant,
      fontWeight,
      fontSize,
      fontFamily,
      letterSpacing,
    } = this.style;

    context.font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize} ${fontFamily}`;
    context.letterSpacing = letterSpacing;

    const width = context.measureText(value).width;
    element.remove();
    return width;
  }
}
